const FAVOURITES_KEY = 'norderm_favourites';

const favSlugify = (value) => (value || '')
  .toString()
  .toLowerCase()
  .replace(/å/g, 'a')
  .replace(/æ/g, 'ae')
  .replace(/ø/g, 'o')
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-|-$/g, '');

function getFavourites() {
  try { return JSON.parse(localStorage.getItem(FAVOURITES_KEY)) || []; }
  catch (e) { return []; }
}

function setFavourites(list) {
  localStorage.setItem(FAVOURITES_KEY, JSON.stringify(list));
}

function favHeartId(heart) {
  const card = heart.closest('.product-card');
  const name = card?.querySelector('.product-name')?.textContent.trim() || '';
  return { card, id: favSlugify(name), name };
}

function syncHeartButtons() {
  const ids = getFavourites().map((item) => item.id);
  document.querySelectorAll('[data-heart]').forEach((heart) => {
    const { id } = favHeartId(heart);
    if (!id) return;
    const on = ids.includes(id);
    heart.classList.toggle('on', on);
    heart.setAttribute('aria-pressed', on ? 'true' : 'false');
  });
}

function favEscapeHtml(value) {
  return String(value || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
}

function renderFavouritesGrid() {
  const grid = document.querySelector('.fav-grid');
  if (!grid) return;
  const favourites = getFavourites();
  const empty = document.querySelector('.fav-empty');
  if (!favourites.length) {
    grid.innerHTML = '';
    if (empty) empty.hidden = false;
    return;
  }
  if (empty) empty.hidden = true;
  grid.innerHTML = favourites.map((item) => `<a class="product-card" href="${item.href}">
    <div class="product-photo"><img src="${item.image}" alt="${favEscapeHtml(item.name)}"></div>
    <div class="product-meta">
      <div>
        <div class="product-brand">${favEscapeHtml(item.brand)}</div>
        <div class="product-name">${favEscapeHtml(item.name)}</div>
        <div class="product-price" data-price-value="${favEscapeHtml(item.price)}" hidden></div>
      </div>
      <button class="heart on" data-heart aria-label="Favoritt"><svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M12 20s-7.2-4.4-9.1-8.2C1.4 8.8 3.1 5 6.5 5c2 0 3.3 1.1 4 2.2C11.2 6.1 12.5 5 14.5 5c3.4 0 5.1 3.8 3.6 6.8C19.2 15.6 12 20 12 20Z"/></svg></button>
    </div>
  </a>`).join('');
  revealGatedPrices();
}

syncHeartButtons();
if (document.body.classList.contains('favourites-page')) {
  renderFavouritesGrid();
}

document.addEventListener('click', (event) => {
  const search = document.querySelector('.search-overlay');
  const menu = document.querySelector('.mobile-menu');
  if (event.target.closest('[data-search]')) {
    search?.classList.add('open');
    setTimeout(() => search?.querySelector('input')?.focus(), 40);
  }
  if (event.target.closest('[data-sclose]')) search?.classList.remove('open');
  if (event.target.closest('[data-burger]')) menu?.classList.add('open');
  if (event.target.closest('[data-mclose]')) menu?.classList.remove('open');
  const heart = event.target.closest('[data-heart]');
  if (heart) {
    event.preventDefault();
    const { card, id, name } = favHeartId(heart);
    if (!id) {
      heart.classList.toggle('on');
      heart.setAttribute('aria-pressed', heart.classList.contains('on') ? 'true' : 'false');
      return;
    }
    const favourites = getFavourites();
    const idx = favourites.findIndex((item) => item.id === id);
    let isOn;
    if (idx > -1) {
      favourites.splice(idx, 1);
      isOn = false;
    } else {
      favourites.push({
        id,
        name,
        brand: card.querySelector('.product-brand')?.textContent.trim() || '',
        image: card.querySelector('.product-photo img')?.getAttribute('src') || '',
        href: card.getAttribute('href') || '',
        price: card.querySelector('.product-price')?.getAttribute('data-price-value') || ''
      });
      isOn = true;
    }
    setFavourites(favourites);
    document.querySelectorAll('[data-heart]').forEach((other) => {
      const otherInfo = favHeartId(other);
      if (otherInfo.id === id) {
        other.classList.toggle('on', isOn);
        other.setAttribute('aria-pressed', isOn ? 'true' : 'false');
      }
    });
    if (document.body.classList.contains('favourites-page')) {
      renderFavouritesGrid();
    }
  }
  const testimonialButton = event.target.closest('[data-testimonial]');
  if (testimonialButton) {
    const section = testimonialButton.closest('.main1513-testimonial');
    const quote = section?.querySelector('blockquote');
    const author = section?.querySelector('.main1513-testimonial-author');
    const count = section?.querySelector('.main1513-testimonial-count');
    const slides = section?._testimonials;
    if (section && quote && author && count && slides?.length) {
      const dir = Number(testimonialButton.dataset.testimonial) || 1;
      const nextIndex = (section._testimonialIndex + dir + slides.length) % slides.length;
      const nextSlide = slides[nextIndex];
      section.classList.add('is-switching');
      window.clearTimeout(section._testimonialTimer);
      section._testimonialTimer = window.setTimeout(() => {
        quote.textContent = nextSlide.quote;
        author.textContent = nextSlide.author;
        count.textContent = `${nextIndex + 1}/${slides.length}`;
        section._testimonialIndex = nextIndex;
        section.classList.remove('is-switching');
      }, 180);
    }
    return;
  }
  /* The [data-scroll] arrows are driven by the rail carousel below — it owns
     the offset so the arrows and the looping logic stay in step. */
});

/* Homepage product rail — drag-to-scroll plus the two arrow buttons, looping
   endlessly in both directions.

   The loop is built by cloning the whole card set until the track holds one
   full set plus everything the viewport can show mid-slide, then keeping the
   offset inside (-setWidth, 0]. The content repeats exactly every setWidth, so
   snapping the offset back by one set lands on a pixel-identical picture and
   can be done between frames without the user ever seeing the seam.

   Only desktop gets the clones: below 1001px .main1513-products is a native
   overflow-x:auto scroller and the arrows are hidden (see page-index.liquid),
   so cloned cards there would just look like the catalogue repeating itself. */
(function railCarousel() {
  const rail = document.getElementById('productRail');
  if (!rail) return;
  const viewport = rail.parentElement;
  const desktop = window.matchMedia('(min-width: 1001px)');
  const originals = Array.from(rail.children);
  if (!originals.length) return;

  const CLONE_ATTR = 'data-rail-clone';
  let setWidth = 0;    // one full set of the original cards, flex gaps included
  let cardStep = 360;  // how far one arrow press travels
  let looping = false;
  let offset = 0;
  let settleTimer = null;

  const viewportWidth = () => (viewport && viewport.clientWidth) || rail.clientWidth || 0;

  function addCloneSet() {
    originals.forEach((node) => {
      const clone = node.cloneNode(true);
      clone.setAttribute(CLONE_ATTR, '');
      clone.setAttribute('aria-hidden', 'true');
      // Keep the duplicates out of the tab order — they are the same products.
      clone.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
      rail.appendChild(clone);
    });
  }

  function teardown() {
    rail.querySelectorAll(`[${CLONE_ATTR}]`).forEach((node) => node.remove());
    looping = false;
    setWidth = 0;
  }

  function build() {
    teardown();
    if (!desktop.matches) return;

    addCloneSet();
    // offsetLeft ignores transforms, so this measures the true layout pitch of
    // one set (card widths plus the gaps between them) whatever the offset is.
    setWidth = rail.children[originals.length].offsetLeft - originals[0].offsetLeft;
    if (!(setWidth > 0)) {
      teardown();
      return;
    }
    cardStep = originals.length > 1
      ? originals[1].offsetLeft - originals[0].offsetLeft
      : setWidth;

    // Enough material that a slide may overshoot a whole set by one step and
    // still have cards covering the viewport.
    const needed = setWidth + viewportWidth() + cardStep + 16;
    let guard = 12;
    while (setWidth * (rail.children.length / originals.length) < needed && guard > 0) {
      addCloneSet();
      guard -= 1;
    }
    looping = true;

    // Prices are gated and only revealed further down this file, after this
    // runs — the clones were taken while they were still hidden, so re-run the
    // reveal to bring them in line with the originals.
    revealGatedPrices();
  }

  function wrap(value) {
    if (looping && setWidth > 0) {
      let next = value;
      while (next <= -setWidth) next += setWidth;
      while (next > 0) next -= setWidth;
      return next;
    }
    const maxOffset = -(rail.scrollWidth - viewportWidth());
    return Math.max(maxOffset, Math.min(0, value));
  }

  function apply(value, animate) {
    offset = value;
    rail._slideOffset = value;
    rail.style.transition = animate ? 'transform .7s cubic-bezier(.22,1,.36,1)' : 'none';
    rail.style.transform = `translateX(${value}px)`;
  }

  function settle() {
    if (settleTimer) {
      clearTimeout(settleTimer);
      settleTimer = null;
    }
    const wrapped = wrap(offset);
    if (wrapped === offset) return;
    apply(wrapped, false);
    void rail.offsetWidth; // commit the snap before anything animates out of it
  }

  document.addEventListener('click', (event) => {
    const scroller = event.target.closest('[data-scroll]');
    if (!scroller) return;
    settle();
    apply(offset - (Number(scroller.dataset.scroll) || 1) * cardStep, true);
    settleTimer = setTimeout(settle, 760);
  });

  let dragging = false;
  let moved = false;
  let startX = 0;
  let startOffset = 0;

  // A card is a link wrapped round an image, so pressing and moving started the
  // browser's own drag-and-drop: the pointer picked the photo up and carried a
  // ghost of it instead of scrolling the rail (very visible on macOS).
  // Cancelling dragstart kills that without affecting ordinary clicks.
  rail.addEventListener('dragstart', (event) => event.preventDefault());

  rail.addEventListener('mousedown', (event) => {
    if (event.button !== 0) return;
    settle();
    dragging = true;
    moved = false;
    startX = event.clientX;
    startOffset = offset;
    // No preventDefault/drag styling here yet — a plain click (mousedown then
    // mouseup with no real movement) must reach the product link / heart
    // button untouched. Drag mode only engages once actual movement crosses
    // the threshold, in mousemove below.
  });

  window.addEventListener('mousemove', (event) => {
    if (!dragging) return;
    const dx = event.clientX - startX;
    if (!moved && Math.abs(dx) > 4) {
      moved = true;
      rail.classList.add('is-dragging');
    }
    if (!moved) return;
    // dx is a real screen-pixel delta from the mouse; the rail lives inside
    // the zoomed canvas (body{zoom:...}, see norderm-responsive.css) where a
    // plain translateX px is a logical (pre-zoom) unit, so divide dx back
    // into that space or the rail visibly out/under-runs the cursor at any
    // zoom other than 1 (widths other than exactly 1512).
    const zoom = (window.__nordermDesktopZoom || 1);
    apply(wrap(startOffset + dx / zoom), false);
  });

  window.addEventListener('mouseup', () => {
    if (!dragging) return;
    dragging = false;
    if (moved) {
      rail.classList.remove('is-dragging');
      rail.style.transition = 'transform .35s cubic-bezier(.22,1,.36,1)';
    }
  });

  rail.addEventListener('click', (event) => {
    if (moved) {
      event.preventDefault();
      event.stopPropagation();
    }
    moved = false;
  }, true);

  function rebuild() {
    apply(0, false);
    build();
  }

  let resizeTimer = null;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(rebuild, 200);
  });
  if (typeof desktop.addEventListener === 'function') desktop.addEventListener('change', rebuild);
  // Late webfonts or stylesheets can change the measurement; only worth redoing
  // if the first attempt could not establish the loop.
  window.addEventListener('load', () => {
    if (!looping && desktop.matches) rebuild();
  });

  build();
})();

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    document.querySelector('.catalog-filter-shell.is-open')?.closeDrawer?.();
    document.querySelector('.search-overlay')?.classList.remove('open');
    document.querySelector('.mobile-menu')?.classList.remove('open');
  }
});

document.querySelectorAll('.brand-strip div').forEach((node) => {
  node.innerHTML = node.innerHTML + node.innerHTML;
});

const catalogRoot = document.querySelector('.catalog-page .catalog-layout');
if (catalogRoot) {
  const pageCategory = document.body.dataset.catalogCategory || new URLSearchParams(window.location.search).get('category') || '';
  const grid = catalogRoot.querySelector('.product-grid');
  const countNode = catalogRoot.querySelector('.catalog-bar > span');
  const pagination = catalogRoot.querySelector('.pagination');
  const catalogBar = catalogRoot.querySelector('.catalog-bar');
  const catalogMain = catalogRoot.querySelector('.catalog-main');
  const filters = catalogRoot.querySelector('.filters');
  const mobileFilterMq = window.matchMedia('(max-width: 620px)');
  const pageSize = 9;
  let currentPage = Number(pagination?.querySelector('.active')?.textContent) || 1;
  let activeFilterGroup = null;

  const slugify = (value) => (value || '')
    .toString()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/å/g, 'a')
    .replace(/æ/g, 'ae')
    .replace(/ø/g, 'o')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

  const groupLabel = (group) => (group.querySelector('h2')?.childNodes[0]?.textContent || '').trim();
  const groupKey = (group) => slugify(groupLabel(group));
  const labelText = (input) => Array.from(input.closest('label').childNodes)
    .filter((node) => node.nodeType === Node.TEXT_NODE)
    .map((node) => node.textContent)
    .join(' ')
    .trim();
  const selectedValues = (key) => filterGroups
    .filter((group) => groupKey(group) === key)
    .flatMap((group) => Array.from(group.querySelectorAll('input:checked')).map((input) => slugify(labelText(input))));

  /* Category list comes from whatever Type values actually exist on products
     (window.nordermCategories, set in page-products.liquid from
     collections.all.products | map: 'type' | uniq) — no hardcoded category
     list here, so a brand-new Type shows up in the title, filter and menu
     without touching this file. */
  const dynamicCategoryOptions = (Array.isArray(window.nordermCategories) ? window.nordermCategories : [])
    .map((label) => ({ label, value: slugify(label) }));

  const pageTitle = document.querySelector('.page-intro h1');
  if (pageTitle && !document.body.classList.contains('search-page')) {
    const matchedCategory = dynamicCategoryOptions.find((option) => option.value === pageCategory);
    pageTitle.textContent = (matchedCategory && matchedCategory.label) || 'Utforsk alle produkter';
  }

  const iconFilter = '<svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 6h16l-6.5 7.2V18l-3 1.6v-6.4L4 6Z"/></svg>';
  const iconSection = '<svg class="ic" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M5 12h14"/></svg>';
  const iconChevron = '<svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m8 10 4 4 4-4"/></svg>';
  const iconBack = '<svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m14 18-6-6 6-6"/></svg>';
  const iconClose = '<svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m6 6 12 12M18 6 6 18"/></svg>';
  const iconCheck = '<svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="m5 12 4.2 4.2L19 6.8"/></svg>';

  const gridCards = grid ? Array.from(grid.querySelectorAll('.product-card')) : [];
  const hasBestOffer = gridCards.some((card) => card.dataset.best === 'true');
  const hasTopSeller = gridCards.some((card) => card.dataset.top === 'true');

  const catalogFilterSections = [
    {
      key: 'kategorier',
      title: 'Kategorier',
      options: [
        ...(hasBestOffer ? [{ label: 'Beste tilbud', value: 'beste-tilbud' }] : []),
        ...(hasTopSeller ? [{ label: 'Top selgere', value: 'top-selgere' }] : []),
        ...dynamicCategoryOptions
      ]
    },
    {
      key: 'merke',
      title: 'Merke',
      options: Array.isArray(window.nordermVendors) && window.nordermVendors.length
        ? window.nordermVendors
        : []
    },
    {
      key: 'tilgjengelighet',
      title: 'Tilgjengelighet',
      options: [
        { label: 'På lager', value: 'pa-lager', checked: true },
        { label: 'Ikke på lager', value: 'ikke-pa-lager' }
      ]
    }
  ];

  const buildCatalogFilterMarkup = () => catalogFilterSections.map((section) => {
    const isCategorySection = section.key === 'kategorier';
    const options = section.options.map((option) => {
      const checked = isCategorySection ? option.value === pageCategory : Boolean(option.checked);
      return `<label class="filter-check${checked ? ' selected' : ''}"><input type="checkbox"${checked ? ' checked' : ''}><span>${iconCheck}</span>${option.label}</label>`;
    }).join('');
    return `<div class="filter-group">
          <h2>${section.title}<span>${iconSection}</span></h2>
          ${options}
        </div>`;
  }).join('');

  if (filters) {
    filters.innerHTML = buildCatalogFilterMarkup();
  }
  const filterGroups = Array.from(catalogRoot.querySelectorAll('.filter-group'));

  if (catalogBar) {
    const sortButton = catalogBar.querySelector('button');
    if (sortButton) sortButton.classList.add('catalog-sort-button');
  }

  filterGroups.forEach((group, index) => {
    const heading = group.querySelector('h2');
    if (!heading) return;
    if (!group.id) group.id = `catalog-filter-group-${index}`;
    let body = group.querySelector('.filter-group-body');
    if (!body) {
      body = document.createElement('div');
      body.className = 'filter-group-body';
      const inner = document.createElement('div');
      inner.className = 'filter-group-body-inner';
      while (heading.nextSibling) {
        inner.appendChild(heading.nextSibling);
      }
      body.appendChild(inner);
      group.appendChild(body);
    }
    heading.setAttribute('role', 'button');
    heading.setAttribute('tabindex', '0');
    heading.setAttribute('aria-controls', group.id);
    heading.setAttribute('aria-expanded', 'true');
    const toggleGroup = () => {
      const collapsed = group.classList.toggle('is-collapsed');
      heading.setAttribute('aria-expanded', String(!collapsed));
    };
    heading.addEventListener('click', toggleGroup);
    heading.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleGroup();
      }
    });
  });

  const filterTrigger = document.createElement('button');
  filterTrigger.type = 'button';
  filterTrigger.className = 'catalog-filter-trigger';
  filterTrigger.setAttribute('aria-label', 'Filtrer');
  filterTrigger.setAttribute('aria-expanded', 'false');
  filterTrigger.innerHTML = `${iconFilter}<span class="catalog-filter-trigger-count" aria-hidden="true"></span><span class="sr-only">Åpne filter</span>`;
  if (catalogBar) {
    const sortButton = catalogBar.querySelector('.catalog-sort-button');
    if (sortButton) {
      sortButton.after(filterTrigger);
    } else {
      catalogBar.appendChild(filterTrigger);
    }
  }

  const filterShell = document.createElement('div');
  filterShell.className = 'catalog-filter-shell';
  filterShell.setAttribute('aria-hidden', 'true');
  filterShell.inert = true;
  filterShell.dataset.view = 'root';
  filterShell.innerHTML = `
    <button type="button" class="catalog-filter-backdrop" aria-label="Lukk filter"></button>
    <div class="catalog-filter-sheet" role="dialog" aria-modal="true" aria-labelledby="catalog-filter-title">
      <div class="catalog-filter-head">
        <button type="button" class="catalog-filter-icon-button catalog-filter-back" data-filter-back aria-label="Tilbake">${iconBack}</button>
        <div class="catalog-filter-head-title" id="catalog-filter-title">Filtrer produkter</div>
        <button type="button" class="catalog-filter-icon-button catalog-filter-close" data-filter-close aria-label="Lukk">${iconClose}</button>
      </div>
      <div class="catalog-filter-stage">
        <div class="catalog-filter-panels">
          <section class="catalog-filter-pane catalog-filter-pane-root" aria-label="Filtervalg"></section>
          <section class="catalog-filter-pane catalog-filter-pane-detail" aria-label="Valgt filter"></section>
        </div>
      </div>
      <div class="catalog-filter-foot">
        <button type="button" class="btn primary catalog-filter-apply" data-filter-close>Vis produkter</button>
      </div>
    </div>`;
  catalogRoot.appendChild(filterShell);

  const filterBackdrop = filterShell.querySelector('.catalog-filter-backdrop');
  const filterSheet = filterShell.querySelector('.catalog-filter-sheet');
  const filterRootPane = filterShell.querySelector('.catalog-filter-pane-root');
  const filterDetailPane = filterShell.querySelector('.catalog-filter-pane-detail');
  const filterBackButton = filterShell.querySelector('.catalog-filter-back');
  const filterDetailTitle = filterShell.querySelector('.catalog-filter-head-title');
  const filterApplyCount = filterShell.querySelector('.catalog-filter-apply-count');
  const filterTriggerCount = filterTrigger.querySelector('.catalog-filter-trigger-count');
  const filterHomeParent = filters?.parentNode || null;
  const filterHomeNext = filters?.nextSibling || null;

  const rootList = document.createElement('div');
  rootList.className = 'catalog-filter-root-list';
  filterGroups.forEach((group) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'catalog-filter-root-item';
    button.dataset.filterOpenGroup = group.id;
    button.innerHTML = `
      <span class="catalog-filter-root-copy">
        <strong>${groupLabel(group)}</strong>
        <small class="catalog-filter-root-summary">Alle</small>
      </span>
      <span class="catalog-filter-root-chevron">${iconChevron}</span>`;
    rootList.appendChild(button);
  });
  filterRootPane.appendChild(rootList);

  const filterDetailTop = document.createElement('div');
  filterDetailTop.className = 'catalog-filter-detail-top';
  filterDetailTop.appendChild(filterBackButton);
  filterDetailTop.appendChild(filterDetailTitle);
  const filterDetailBody = document.createElement('div');
  filterDetailBody.className = 'catalog-filter-detail-body';
  if (filters) filterDetailBody.appendChild(filters);
  filterDetailPane.append(filterDetailTop, filterDetailBody);

  const rootButtons = Array.from(rootList.querySelectorAll('.catalog-filter-root-item'));
  const totalSelectedCount = () => filterGroups.reduce((total, group) => total + group.querySelectorAll('.filter-check input:checked').length, 0);

  const showAllGroups = () => {
    filterGroups.forEach((group) => {
      group.hidden = false;
    });
    activeFilterGroup = null;
  };

  const showOnlyGroup = (group) => {
    filterGroups.forEach((item) => {
      item.hidden = item !== group;
    });
    activeFilterGroup = group;
  };

  const setDrawerView = (view) => {
    filterShell.dataset.view = view;
    filterBackButton.disabled = view === 'root';
    filterRootPane.setAttribute('aria-hidden', String(view !== 'root'));
    filterDetailPane.setAttribute('aria-hidden', String(view !== 'detail'));
    if (view === 'root') {
      showAllGroups();
      filterDetailTitle.textContent = 'Filtrer produkter';
    } else if (activeFilterGroup) {
      filterDetailTitle.textContent = groupLabel(activeFilterGroup);
    }
  };

  const updateFilterUI = () => {
    const total = totalSelectedCount();
    if (filterTriggerCount) filterTriggerCount.textContent = total > 0 ? String(total) : '';
    filterTrigger.classList.toggle('has-count', total > 0);
    filterTrigger.classList.toggle('is-active', filterShell.classList.contains('is-open'));
    filterTrigger.setAttribute('aria-expanded', String(filterShell.classList.contains('is-open')));
    if (filterApplyCount) filterApplyCount.textContent = total > 0 ? ` (${total})` : '';
    rootButtons.forEach((button) => {
      const group = filterGroups.find((item) => item.id === button.dataset.filterOpenGroup);
      const count = group ? group.querySelectorAll('.filter-check input:checked').length : 0;
      const summary = button.querySelector('.catalog-filter-root-summary');
      if (summary) summary.textContent = count ? `${count} valgt` : 'Alle';
      button.classList.toggle('has-selection', count > 0);
    });
  };

  const closeDrawer = ({ focusTrigger = true } = {}) => {
    filterShell.classList.remove('is-open');
    filterShell.setAttribute('aria-hidden', 'true');
    filterShell.inert = true;
    document.body.classList.remove('catalog-filters-open');
    setDrawerView('root');
    updateFilterUI();
    if (focusTrigger) {
      window.setTimeout(() => filterTrigger.focus({ preventScroll: true }), 40);
    }
  };

  const openDrawer = ({ focusRoot = true } = {}) => {
    if (!mobileFilterMq.matches || !filters) return;
    if (filters.parentNode !== filterDetailBody) filterDetailBody.appendChild(filters);
    showAllGroups();
    filterShell.classList.add('is-open');
    document.body.classList.add('catalog-filters-open');
    filterShell.setAttribute('aria-hidden', 'false');
    filterShell.inert = false;
    setDrawerView('root');
    updateFilterUI();
    if (focusRoot) {
      window.setTimeout(() => rootButtons[0]?.focus({ preventScroll: true }), 40);
    }
  };

  const openGroup = (groupId) => {
    if (!mobileFilterMq.matches) return;
    const group = filterGroups.find((item) => item.id === groupId);
    if (!group) return;
    openDrawer({ focusRoot: false });
    if (filters?.parentNode !== filterDetailBody) filterDetailBody.appendChild(filters);
    showOnlyGroup(group);
    group.classList.remove('is-collapsed');
    const heading = group.querySelector('h2');
    if (heading) heading.setAttribute('aria-expanded', 'true');
    activeFilterGroup = group;
    filterShell.classList.add('is-open');
    document.body.classList.add('catalog-filters-open');
    filterShell.setAttribute('aria-hidden', 'false');
    filterShell.inert = false;
    setDrawerView('detail');
    updateFilterUI();
    filterBackButton.focus({ preventScroll: true });
  };

  filterShell.openDrawer = openDrawer;
  filterShell.closeDrawer = closeDrawer;
  filterShell.openGroup = openGroup;

  const syncFilterPlacement = () => {
    if (!filters) return;
    if (mobileFilterMq.matches) {
      if (filters.parentNode !== filterDetailBody) filterDetailBody.appendChild(filters);
      filterTrigger.hidden = false;
    } else {
      closeDrawer({ focusTrigger: false });
      showAllGroups();
      if (filterHomeParent && filters.parentNode !== filterHomeParent) {
        if (filterHomeNext && filterHomeNext.parentNode === filterHomeParent) {
          filterHomeParent.insertBefore(filters, filterHomeNext);
        } else if (catalogMain) {
          filterHomeParent.insertBefore(filters, catalogMain);
        } else {
          filterHomeParent.appendChild(filters);
        }
      }
    }
    updateFilterUI();
  };

  catalogRoot.addEventListener('click', (event) => {
    const openGroupButton = event.target.closest('[data-filter-open-group]');
    if (openGroupButton) {
      event.preventDefault();
      openGroup(openGroupButton.dataset.filterOpenGroup);
      return;
    }
    if (event.target.closest('[data-filter-back]')) {
      event.preventDefault();
      setDrawerView('root');
      updateFilterUI();
      return;
    }
    if (event.target.closest('.catalog-filter-trigger')) {
      event.preventDefault();
      openDrawer();
      return;
    }
    if (event.target.closest('[data-filter-close]') || event.target.closest('.catalog-filter-backdrop')) {
      event.preventDefault();
      closeDrawer({ focusTrigger: true });
    }
  });

  if (mobileFilterMq.addEventListener) {
    mobileFilterMq.addEventListener('change', syncFilterPlacement);
  } else if (mobileFilterMq.addListener) {
    mobileFilterMq.addListener(syncFilterPlacement);
  }

  /* Keep available items at the top of the catalogue while preserving the
     existing order within the available and sold-out groups. */
  if (grid) {
    Array.from(grid.querySelectorAll('.product-card'))
      .sort((first, second) => Number(first.dataset.stock !== 'pa-lager') - Number(second.dataset.stock !== 'pa-lager'))
      .forEach((card) => grid.appendChild(card));
  }

  const cards = Array.from(grid?.querySelectorAll('.product-card') || []);

  const categoryGroup = filterGroups.find((group) => groupKey(group) === 'kategorier');
  filterGroups
    .filter((group) => group !== categoryGroup)
    .forEach((group) => {
      group.querySelectorAll('.filter-check').forEach((label) => {
        const input = label.querySelector('input');
        if (input) input.checked = false;
        label.classList.remove('selected');
      });
    });
  if (categoryGroup) {
    Array.from(categoryGroup.querySelectorAll('label')).forEach((label) => {
      const input = label.querySelector('input');
      const value = slugify(labelText(input));
      const shouldCheck = pageCategory && value === pageCategory;
      input.checked = Boolean(shouldCheck);
      label.classList.toggle('selected', Boolean(shouldCheck));
    });
  }

  document.querySelectorAll('.catalog-page .category-pills a').forEach((link) => {
    const slug = slugify(link.textContent.trim());
    link.classList.toggle('is-current', Boolean(pageCategory && slug === pageCategory));
  });

  const matchesFilters = (card) => {
    const categories = selectedValues('kategorier');
    const brands = selectedValues('merke');
    const stocks = selectedValues('tilgjengelighet');
    const categoryOnly = categories.filter((value) => !['beste-tilbud', 'top-selgere'].includes(value));
    const wantsBest = categories.includes('beste-tilbud');
    const wantsTop = categories.includes('top-selgere');
    const categoryOk = !categoryOnly.length || categoryOnly.includes(card.dataset.category);
    const bestOk = !wantsBest || card.dataset.best === 'true';
    const topOk = !wantsTop || card.dataset.top === 'true';
    const brandOk = !brands.length || brands.includes(card.dataset.brand);
    const stockOk = !stocks.length || stocks.includes(card.dataset.stock);
    return categoryOk && bestOk && topOk && brandOk && stockOk;
  };

  const renderCatalog = () => {
    const filtered = cards.filter(matchesFilters);
    const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
    currentPage = Math.min(Math.max(currentPage, 1), totalPages);
    const start = (currentPage - 1) * pageSize;
    const pageItems = new Set(filtered.slice(start, start + pageSize));
    cards.forEach((card) => {
      card.hidden = !pageItems.has(card);
    });
    if (countNode) {
      countNode.textContent = `${filtered.length} Produkter`;
    }
    if (!pagination) return;
    pagination.innerHTML = '';

    const createNav = (label, direction) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `page-nav page-${direction < 0 ? 'prev' : 'next'}`;
      button.disabled = direction < 0 ? currentPage <= 1 : currentPage >= totalPages;
      button.dataset.pageDirection = direction;
      const arrow = direction < 0
        ? '<svg class="ic" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.25 4.5L6.75 9L11.25 13.5" stroke="currentColor" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        : '<svg class="ic" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.75 13.5L11.25 9L6.75 4.5" stroke="currentColor" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      button.innerHTML = direction < 0 ? `${arrow}<span>${label}</span>` : `<span>${label}</span>${arrow}`;
      return button;
    };

    pagination.appendChild(createNav('Forrige', -1));
    const numbers = document.createElement('div');
    numbers.className = 'page-numbers';
    for (let page = 1; page <= totalPages; page += 1) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `page-number${page === currentPage ? ' active' : ''}`;
      button.dataset.page = page;
      button.textContent = page;
      numbers.appendChild(button);
    }
    pagination.appendChild(numbers);
    pagination.appendChild(createNav('Neste', 1));
  };

  catalogRoot.addEventListener('change', (event) => {
    const input = event.target.closest('.filter-check input');
    if (!input) return;
    input.closest('.filter-check')?.classList.toggle('selected', input.checked);
    currentPage = 1;
    renderCatalog();
    updateFilterUI();
  });

  pagination?.addEventListener('click', (event) => {
    const pageButton = event.target.closest('[data-page]');
    const dirButton = event.target.closest('[data-page-direction]');
    if (pageButton) {
      currentPage = Number(pageButton.dataset.page) || 1;
      renderCatalog();
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }
    if (dirButton && !dirButton.disabled) {
      currentPage += Number(dirButton.dataset.pageDirection) || 0;
      renderCatalog();
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }
  });

  syncFilterPlacement();
  updateFilterUI();
  renderCatalog();
}

const testimonialSection = document.querySelector('.main1513-testimonial');
if (testimonialSection) {
  testimonialSection._testimonials = [
    {
      quote: '\u00abF\u00f8r NorDerm m\u00e5tte jeg jakte p\u00e5 leverand\u00f8ren hver gang for sertifikater og LOT-nummer. N\u00e5 st\u00e5r alt rett p\u00e5 produktsiden f\u00f8r jeg bestiller. Det alene er verdt byttet.\u00bb',
      author: '\u2014 Aesthetic nurse, solo practice, Oslo'
    },
    {
      quote: '\u00abDet som overbeviste oss var ikke bare pris, men hvor raskt teamet svarer. Vi f\u00e5r tydelige svar, sporingslenke med en gang og slipper usikkerhet rundt leveransen.\u00bb',
      author: '\u2014 Clinic manager, Bergen'
    },
    {
      quote: '\u00abJeg bestiller ofte mellom behandlinger. Med NorDerm ser jeg dokumentasjon og utl\u00f8psdato f\u00f8r checkout, s\u00e5 jeg kan ta raske beslutninger uten \u00e5 sende ekstra e-poster.\u00bb',
      author: '\u2014 Cosmetic doctor, Trondheim'
    },
    {
      quote: '\u00abTidligere brukte vi un\u00f8dig mye tid p\u00e5 \u00e5 bekrefte partier og lagerstatus. N\u00e5 ligger alt samlet, og hele teamet bestiller tryggere og langt raskere.\u00bb',
      author: '\u2014 Procurement lead, Stavanger'
    },
    {
      quote: '\u00abDet merkes at NorDerm er bygget for klinikker. Vi har f\u00e5tt bedre flyt i innkj\u00f8pene, og pasientdagene blir enklere \u00e5 planlegge n\u00e5r leveransene faktisk er forutsigbare.\u00bb',
      author: '\u2014 Founder, aesthetic studio, Drammen'
    },
    {
      quote: '\u00abVi byttet leverand\u00f8r for \u00e5 spare tid, og det gjorde vi. Nettbutikken, dokumentasjonen og supporten henger sammen p\u00e5 en m\u00e5te som gj\u00f8r hverdagen merkbart lettere.\u00bb',
      author: '\u2014 Head nurse, private clinic, Troms\u00f8'
    }
  ];
  testimonialSection._testimonialIndex = 0;
  const quote = testimonialSection.querySelector('blockquote');
  const author = testimonialSection.querySelector('.main1513-testimonial-author');
  const count = testimonialSection.querySelector('.main1513-testimonial-count');
  if (quote && author && count) {
    quote.textContent = testimonialSection._testimonials[0].quote;
    author.textContent = testimonialSection._testimonials[0].author;
    count.textContent = `1/${testimonialSection._testimonials.length}`;
  }
}

function revealGatedPrices() {
  function getCookie(name) {
    const m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : null;
  }
  let loggedIn = false;
  try {
    const raw = getCookie('norderm_customer_token');
    loggedIn = !!(raw && JSON.parse(raw).accessToken);
  } catch (e) { loggedIn = false; }
  if (!loggedIn) return;
  document.querySelectorAll('[data-price-value]').forEach((el) => {
    el.textContent = el.dataset.priceValue;
    el.hidden = false;
  });
}
revealGatedPrices();

/* Quick add: product cards expose a button only to an authenticated customer
   and only when Shopify marked the product as available. The variant id is
   rendered by Liquid, so adding is a single native Shopify cart request. */
function initQuickAdd() {
  const getCookie = (name) => {
    const match = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return match ? decodeURIComponent(match[1]) : null;
  };
  let loggedIn = false;
  try {
    const raw = getCookie('norderm_customer_token');
    loggedIn = !!(raw && JSON.parse(raw).accessToken);
  } catch (e) { loggedIn = false; }

  const buttons = Array.from(document.querySelectorAll('[data-quick-add]'));
  if (!loggedIn) {
    buttons.forEach((button) => button.remove());
    return;
  }

  const updateCartCount = (cart) => {
    const count = Number(cart?.item_count) || 0;
    let countNode = document.getElementById('header-cart-count');
    if (!countNode && count > 0) {
      const cartLink = document.querySelector('.norderm-mobile-header-cart');
      if (cartLink) {
        countNode = document.createElement('span');
        countNode.id = 'header-cart-count';
        countNode.style.cssText = 'position:absolute;top:-6px;right:-8px;min-width:16px;height:16px;padding:0 3px;border-radius:999px;background:var(--green);color:#fff;font-size:10px;font-weight:700;line-height:16px;text-align:center;font-family:var(--sans);';
        cartLink.appendChild(countNode);
      }
    }
    if (countNode) {
      countNode.textContent = String(count);
      countNode.hidden = count < 1;
    }
  };

  buttons.forEach((button) => {
    const card = button.closest('.product-card');
    const variantId = card?.dataset.variantId;
    const stockSnapshot = card?.dataset.stockSnapshot ?? '';
    if (!card || card.dataset.stock !== 'pa-lager' || !variantId) {
      button.remove();
      return;
    }
    button.hidden = false;
    card.classList.add('quick-add-enabled');
    const label = button.querySelector('span');
    const defaultLabel = label?.textContent || 'Legg i handlekurven';

    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (button.classList.contains('is-loading')) return;
      button.classList.add('is-loading');
      button.disabled = true;
      if (label) label.textContent = 'Legger i handlekurven…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{
            id: Number(variantId),
            quantity: 1,
            properties: { _lager_ved_bestilling: stockSnapshot }
          }]
        })
      })
        .then((response) => {
          if (!response.ok) throw new Error('Cart add failed');
          return response.json();
        })
        .then(() => fetch('/cart.js', { headers: { Accept: 'application/json' } }))
        .then((response) => response.json())
        .then((cart) => {
          updateCartCount(cart);
          button.classList.remove('is-loading');
          button.classList.add('is-success');
          if (label) label.textContent = 'Lagt i handlekurven';
          document.dispatchEvent(new CustomEvent('norderm:cart-updated', { detail: { cart, openDrawer: true } }));
          window.setTimeout(() => {
            button.classList.remove('is-success');
            button.disabled = false;
            if (label) label.textContent = defaultLabel;
          }, 1800);
        })
        .catch(() => {
          button.classList.remove('is-loading');
          button.disabled = false;
          if (label) label.textContent = 'Prøv igjen';
          window.setTimeout(() => { if (label) label.textContent = defaultLabel; }, 1800);
        });
    });
  });
}
initQuickAdd();

/* Cart drawer. The drawer is a presentation layer over Shopify's native
   /cart.js and /cart/change.js endpoints, so quantity, removal and totals
   stay in sync with the existing full cart page. */
(function initCartDrawer() {
  if (window.NordermCartDrawerV2) return;
  const drawer = document.querySelector('[data-cart-drawer]');
  const content = drawer?.querySelector('[data-cart-drawer-content]');
  const totalNode = drawer?.querySelector('[data-cart-drawer-total]');
  const checkoutButton = drawer?.querySelector('[data-cart-drawer-checkout]');
  const headerCart = document.querySelector('.norderm-mobile-header-cart');
  const floatButton = document.querySelector('[data-cart-float]');
  if (!drawer || !content) return;

  const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[char]));
  const formatMoney = (cents) => {
    const amount = ((Number(cents) || 0) / 100).toFixed(2).split('.');
    return amount[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + amount[1] + ' kr';
  };
  const getCookie = (name) => {
    const match = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return match ? decodeURIComponent(match[1]) : null;
  };

  const emptyMarkup = '<div class="norderm-cart-empty"><svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 11L14 20M19 11L15 4M2 11H22M3.5 11L5.1 18.4C5.1935 18.854 5.44485 20.0094 7.1 20H16.9C17.3679 20.0094 17.8243 19.2698 18.1897 19.5621C18.5552 19.2698 18.9 18.4 18.9 18.4L20.6 11M4.5 15.5H19.5M5 11L9 4M9 11L10 20"/><path d="M8 15h8"/></svg><p>Handlekurven er tom.</p></div>';

  function lineMarkup(item) {
    const image = item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '">' : '<div class="norderm-cart-placeholder"></div>';
    return '<article class="norderm-cart-line" data-cart-drawer-line data-key="' + escapeHtml(item.key) + '">' +
      '<div class="norderm-cart-line-photo">' + image + '</div>' +
      '<div class="norderm-cart-line-copy"><span>' + escapeHtml(item.vendor) + '</span><strong>' + escapeHtml(item.product_title) + '</strong><b data-cart-drawer-line-price>' + formatMoney(item.final_line_price) + '</b></div>' +
      '<div class="norderm-cart-line-actions"><div class="norderm-cart-qty"><button type="button" data-cart-decrement aria-label="Reduser antall">−</button><span data-cart-drawer-qty>' + item.quantity + '</span><button type="button" data-cart-increment aria-label="Øk antall">+</button></div><button class="norderm-cart-remove" type="button" data-cart-remove aria-label="Fjern produkt">Fjern</button></div>' +
      '</article>';
  }

  function setCartState(cart) {
    const count = Number(cart?.item_count) || 0;
    if (headerCart) {
      headerCart.dataset.cartHasItems = count > 0 ? 'true' : 'false';
      let countNode = document.getElementById('header-cart-count');
      if (!countNode && count > 0) {
        countNode = document.createElement('span');
        countNode.id = 'header-cart-count';
        countNode.style.cssText = 'position:absolute;top:-6px;right:-8px;min-width:16px;height:16px;padding:0 3px;border-radius:999px;background:var(--green);color:#fff;font-size:10px;font-weight:700;line-height:16px;text-align:center;font-family:var(--sans);';
        headerCart.appendChild(countNode);
      }
      if (countNode) {
        countNode.textContent = String(count);
        countNode.hidden = count < 1;
      }
    }
    if (floatButton) {
      floatButton.hidden = count < 1;
      floatButton.classList.toggle('is-visible', count > 0);
      floatButton.dataset.cartHasItems = count > 0 ? 'true' : 'false';
      const floatCount = floatButton.querySelector('[data-cart-float-count]');
      if (floatCount) floatCount.textContent = String(count);
    }
    if (totalNode) totalNode.textContent = formatMoney(cart?.total_price);
    if (checkoutButton) checkoutButton.disabled = count < 1;
    content.innerHTML = count ? cart.items.map(lineMarkup).join('') : emptyMarkup;
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    }).then((cart) => { setCartState(cart); return cart; });
  }

  function openDrawer() {
    drawer.hidden = false;
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      document.body.classList.add('cart-drawer-open');
    });
    fetchCart().catch(() => {});
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.body.classList.remove('cart-drawer-open');
    window.setTimeout(() => { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 430);
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target?.closest?.('[data-cart-trigger], .norderm-mobile-header-cart');
    if (!trigger) return;
    event.preventDefault();
    openDrawer();
  });
  drawer.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });

  content.addEventListener('click', (event) => {
    const line = event.target.closest('[data-cart-drawer-line]');
    if (!line) return;
    const key = line.dataset.key;
    const qtyNode = line.querySelector('[data-cart-drawer-qty]');
    const current = Number(qtyNode?.textContent) || 1;
    let next = current;
    if (event.target.closest('[data-cart-increment]')) next = Math.min(100, current + 1);
    if (event.target.closest('[data-cart-decrement]')) next = Math.max(0, current - 1);
    if (event.target.closest('[data-cart-remove]')) next = 0;
    if (next === current) return;
    line.classList.add('is-updating');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: next })
    }).then(() => fetchCart()).catch(() => { line.classList.remove('is-updating'); });
  });

  checkoutButton?.addEventListener('click', () => {
    if (checkoutButton.disabled) return;
    checkoutButton.disabled = true;
    checkoutButton.textContent = 'Henter…';
    const raw = getCookie('norderm_customer_token');
    let token = null;
    try { token = raw && JSON.parse(raw).accessToken; } catch (e) { token = null; }
    if (!token) { window.location.href = '/checkout'; return; }
    const gql = (query, variables) => fetch('/api/2025-01/graphql.json', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': '2e3476f69c9731183f16fe2b72775b18' },
      body: JSON.stringify({ query, variables })
    }).then((response) => response.json());
    const query = 'query getCustomerForCheckout($token: String!) { customer(customerAccessToken: $token) { email firstName lastName metafield(namespace: "custom", key: "godkjent_for_b2b_tilgang") { value } defaultAddress { firstName lastName address1 address2 city zip phone country } } }';
    Promise.all([fetch('/cart.js').then((response) => response.json()), gql(query, { token })]).then(([cart, result]) => {
      const customer = result.data && result.data.customer;
      if (!(customer && customer.metafield && customer.metafield.value === 'true')) {
        document.cookie = 'norderm_customer_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
        window.location.href = '/pages/login?return_to=' + encodeURIComponent(window.location.pathname);
        return;
      }
      const identity = { email: customer.email, customerAccessToken: token };
      if (customer.defaultAddress) identity.deliveryAddressPreferences = [{ deliveryAddress: customer.defaultAddress }];
      const mutation = 'mutation cartBuyerIdentityUpdate($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) { cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) { cart { checkoutUrl } userErrors { message } } }';
      return gql(mutation, { cartId: 'gid://shopify/Cart/' + cart.token, buyerIdentity: identity }).then((response) => {
        const checkoutUrl = response.data?.cartBuyerIdentityUpdate?.cart?.checkoutUrl;
        window.location.href = checkoutUrl || '/checkout';
      });
    }).catch(() => { window.location.href = '/checkout'; });
  });

  document.addEventListener('norderm:cart-updated', (event) => {
    if (event.detail) setCartState(event.detail);
    else fetchCart().catch(() => {});
  });
  fetchCart().catch(() => {});
})();
